/**
 *
 * DepartmentType14140 constants
 *
 */

export const BERLINSKY_HOUSE = '4003161797000';
export const GENEVSKY_HOUSE = '4003161806000';
export const ATC_BD_GD_HOUSE = '3865914438000';
